export class Aquisicao {
    quantidadeClientesAquisicao: number;
    quantidadeClientesCarteira: number;
    percTaxaAquisicao: number;
    valorReceitaAquisicao: number;

    constructor(props: Partial<Aquisicao>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Aquisicao {
        return new Aquisicao(JSON.parse(json));
    }
}
